<template lang="pug">
  md-dialog(:md-active.sync="showDialog" @md-closed="$emit('close-dialog', $event)")
    md-dialog-title Proyecto no guardado
    md-dialog-content El proyecto ha sido modificado pero no ha sido guardado. ¿ Desea guardar antes de ir al siguiente formulario ?
    md-dialog-actions
      md-button.md-raised(@click="$emit('go-back', $event)") Volver atrás
      md-button.md-raised.md-primary(@click="$emit('save-confirm', $event)") Si
      md-button.md-raised.md-accent(@click="$emit('save-cancel', $event)") No
</template>

<script>
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  }
}
</script>
